import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import Breadcrumb from './breadcrumb';
import { useScreenSize } from '../../utils';

import styles from '../styles/uikitLayoutsBreadcrumbs.module.scss';

const Breadcrumbs = ({
  breadcrumbs = [],
  className = '',
  shouldInvertBreadcrumbs = false,
  shouldShowAllAsActive = false,
}) => {
  const screenSize = useScreenSize();
  const isNarrow = screenSize === 'xsmall' || screenSize === 'small';

  return (
    <nav
      className={classnames(styles.element, className, {
        [styles.isInverted]: shouldInvertBreadcrumbs,
      })}
      aria-label={i18n.t('breadcrumbs', 'Breadcrumbs')}
    >
      <ol className={styles.list}>
        {breadcrumbs.map((breadcrumb, index) => (
          <Breadcrumb
            key={breadcrumb.key}
            breadcrumb={breadcrumb}
            isCurrentLocation={index === breadcrumbs.length - 1}
            maxChars={isNarrow ? 15 : 45}
            shouldShowAllAsActive={shouldShowAllAsActive}
            shouldShowDivider={index !== breadcrumbs.length - 1}
          />
        ))}
      </ol>
    </nav>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
  shouldInvertBreadcrumbs: PropTypes.bool,
  shouldShowAllAsActive: PropTypes.bool,
};

export { Breadcrumbs as BreadcrumbsStorybook };
export default React.memo(Breadcrumbs);
